import { inject, NewInstance } from 'aurelia-framework';
import { CommodityService } from 'pages/system-fields/commodities/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), CommodityService, EventAggregator)
export class CommodityEditor {
    constructor(controller, validationController, commodityService, ea) {
        this.controller = controller;
        this.commodityService = commodityService;
        this.ea = ea;
        this.commodity = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.commodity = await this.commodityService.getById(model.id);
        }
    }

 

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.commodity.id) {
                    await this.commodityService.update(this.commodity);
                    toastr.success('Commodity was updated!');
                } else {
                    await this.commodityService.create(this.commodity);
                    toastr.success('New commodity was created!');
                }
                this.ea.publish('commodities:updated', this.commodity);
                this.controller.ok(this.commodity);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}